import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { LogIn, LogOut, QrCode, Loader2, AlertCircle } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function QRSignInPage() {
  const { token } = useParams();
  const [status, setStatus] = useState("loading"); // loading | in | out | error
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!token) { setStatus("error"); return; }
    axios.post(`${API}/qr-signin/${token}`)
      .then(r => { setData(r.data); setStatus(r.data.action); })
      .catch(() => setStatus("error"));
  }, [token]);

  const configs = {
    in:  { bg: "from-emerald-600 to-teal-600", Icon: LogIn,   headline: "Signed In!", color: "text-emerald-100" },
    out: { bg: "from-blue-600 to-indigo-600",  Icon: LogOut,  headline: "Signed Out!", color: "text-blue-100" },
    error: { bg: "from-red-600 to-rose-600",   Icon: AlertCircle, headline: "Not Found", color: "text-red-100" },
  };

  if (status === "loading") return (
    <div className="min-h-screen bg-slate-900 flex items-center justify-center">
      <Loader2 className="h-12 w-12 text-teal-400 animate-spin" />
    </div>
  );

  const c = configs[status] || configs.error;
  return (
    <div className={`min-h-screen bg-gradient-to-br ${c.bg} flex flex-col items-center justify-center px-6 text-center`}>
      <c.Icon className={`h-24 w-24 ${c.color} mb-6`} />
      <h1 className="text-white text-5xl font-black mb-4">{c.headline}</h1>
      {data?.childName && <p className="text-white text-2xl font-semibold mb-2">{data.childName}</p>}
      {data?.time && <p className="text-white/70 text-lg">{data.time} · {data.date}</p>}
      {status === "error" && <p className="text-white/60 text-sm mt-4">QR code not recognized. Please contact the center.</p>}
    </div>
  );
}
